<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">设备登录信息</p>
      <div class="content-input">
        <div class="content-input-item">
          <label>性别：</label>
          <el-select v-model="sex" placeholder="Select" style="width: 8em">
            <el-option v-for="item in sexArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>当前登录设备：</label>
          <el-select v-model="emulatorState" placeholder="Select" style="width: 8em" >
            <el-option v-for="item in emulatorStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <SearchComponents :searchTypeList="searchTypeList" :searchType="searchType"  :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />
        </div>
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" @click="getPage(true)" v-loading="searchLoading"> 查询 </ElButtons>
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div style="display: flex; align-items: center;">
<!--          <ElButtons icon="Comment" @click="sendSysMsg">发送通知</ElButtons>-->
<!--          <el-button type="danger" @click="batchReject">批量不通过</el-button>-->
        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            border
            @cell-click="toggleSelection"
            v-loading="listLoading"
            @selection-change="selsChange"
            @header-click="selsAll"
        >
<!--          <el-table-column type="selection" width="55" align="center" class-name="cursor"/>-->
          <el-table-column property="loginTime" label="登录时间" v-if="checkColList.indexOf('登录时间') > -1"/>
          <el-table-column label="当前登录设备" v-if="checkColList.indexOf('当前登录设备') > -1">
            <template #default="scope">
              {{scope.row.emulatorState == 1?'模拟器':scope.row.emulatorState == 2?'真机':''}}
            </template>
          </el-table-column>
          <el-table-column label="用户信息" v-if="checkColList.indexOf('用户信息') > -1">
            <template #default="scope">
              <UserInfoList :row="scope.row" showList="name,phone,uid"/>
            </template>
          </el-table-column>
          <el-table-column label="历史登录记录" v-if="checkColList.indexOf('历史登录记录') > -1" class-name="cursor" >
            <template #default="scope">
              <div v-for="(item, index) in scope.row.emulatorDetailList" :key="index" style="margin: 8px 0">
                <p>{{item.loginTime}} ~ {{item.logoutTime}} </p>
                <p>【{{item.state == 1?'模拟器':item.state == 2?'真机':''}}】使用{{item.dayNum}}天</p>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import DatePickerRange from '../../components/DatePickerRange'
import SearchComponents from '../../components/SearchComponents'
import {
    getEmulatorPageList
} from '../../api/url'
import { getFormData, postJson, postFormData } from '../../api/api'
import Dialog from '../../assets/js/dialog'
import UserLogDialog from '../../components/UserLog/UserLogDialog'
import ImgViewer from '../../assets/js/imageViewer'
import UserLog from "@/components/UserLog/UserLog";
import emulatorList from "@/views/user/components/emulatorList";


export default {
  name: "Emulator",
  components: { DatePickerRange, SearchComponents, UserLog },
  data() {
    return {

      //性别
      sexArray: [
        {label: '不限', value: -1},
        {label: '男', value: 1},
        {label: '女', value: 2},
      ],
      sex: -1,

      // 登录设备
      emulatorStateArray: [
        {label: '不限', value: -1},
        {label: '模拟器', value: 1},
        {label: '真机', value: 2},
      ],
      emulatorState: -1,


      passLoading: false,


      //时间
      startTime: '',
      endTime: '',
      isChecked: true,

      //搜索
      searchTypeList: [
          {label: '手机号码', value: 1},
          {label: '昵称', value: 2},
          {label: 'UID', value: 3},
      ],
      searchType: 1,
      searchValue: '',

      //刷新组
      colList: ['登录时间','当前登录设备', '用户信息', '历史登录记录'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,
      updateLoading: false,

      //选中id
      idArray: [],
      userIdArray: [],
      //选中性别
      userSexArray: [],

    }
  },
  methods: {

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },
    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.isChecked = true;
      this.emulatorState = -1;
      this.sex = -1;
      this.searchValue = '';
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    //获取选中id
    selsChange(sels) {
      this.idArray = sels.map(item => item.userId);
    },

    //全选
    selsAll(column, event) {
      if(column.type == 'selection') {
        let array = this.idArray;
        if(array.length == this.pageDataList.length) {
          array = [];
        }
        this.pageDataList.forEach(item => {
          if(array.indexOf(item.userId) === -1) {
            this.$refs.multipleTableRef.toggleRowSelection(item);
          }
        })
      }
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['sex'] = this.sex;
      param['emulatorState'] = this.emulatorState;
      param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getEmulatorPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },


    //图片预览

    showImg(img) {
      let imgList = []
      imgList.push(img)
      ImgViewer.open({
        imgList
      })
    },

    toggleSelection(row, column, cell, event) {

      if(column.type == 'selection') {
        this.$refs.multipleTableRef.toggleRowSelection(row)
      }

      //更新用户日志
      if(column.label == '历史登录记录') {
        Dialog.open({
          title: '历史登录记录',
          component: emulatorList,
          data: {
            userId: row.userId
          }
        })
      }

    },


  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
  }
}
</script>

<style scoped>
.playBtn {
  font-size: 5em;
  color: #c0c4cc;
  cursor: pointer;
}
.playBtn:hover {
  font-size: 5em;
  color: #3a8ee6;
}
</style>
